import React from "react";
import FeatherIcon from "feather-icons-react";
import Icon from "../Icon";

export default function EditPill({ text, onClick, icon, color, style }) {
  return (
    <button onClick={onClick} className="c-edit-pill">
      <Icon icon="trash" stroke="#fff" size={18} height={18} />
    </button>
  );
}
